const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopSiteSeeLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.7 72.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "222.3 61 222.3 57.5 225.4 59.4 228.3 61 225.4 62.8 222.3 64.5 222.3 61",
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.2,
    cy: 61,
    r: 3.1,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,49.6h-7.6l6.5,20.7c.6,1.5,1.1,2.1,2.6,2.1h2.1v-9l-3.5-13.9h-.1Z",
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9,49.6l-3.5,13.7v9h1.5c1.5,0,2.1-.6,2.6-2.1l6.5-20.7h-7.2Z",
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.2,
    y: 49.6,
    width: 6.9,
    height: 22.6,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,66.7c0-3.3-1.4-4-3.6-4.6h0c2.6-.6,3.9-1.8,3.9-6.1s-.6-4.3-1.5-5.3c-.8-.8-2.1-1.1-4.4-1.1h-5.6v5.1h1.8c1.2,0,1.5,0,1.8.3s.6.8.6,2.1-.1,1.8-.6,2.2c-.1.1-.6.3-1.8.3h-1.8v4.9h1.5c1.4,0,1.7,0,2.1.4.4.3.6.7.6,2.4s.1,3.5.4,5h7.1c0-1.2-.3-3.5-.4-5.7h0Z",
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.4,
    y: 54.9,
    height: 3.5,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,67.1h0v-3.9h0v3.9Z",
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,49.8h-6.8v22.5h6.8v-22.5Z",
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.2,
    y: 49.6,
    width: 9.7,
    height: 5.3,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.2,
    y: 67.1,
    width: 9.7,
    height: 5.3,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 49.6,
    width: 20.4,
    height: 5.3,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.4,
    y: 56.9,
    width: 6.9,
    height: 15.4,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5,66.8c-.1.1-.6.3-1.5.3h-2.9c-1,0-1.2,0-1.5-.3s-.6-.7-.6-4.9h-7.2c0,5.6,1.2,7.9,2.5,9,.8.8,2.1,1.2,4.4,1.2h7.6c2.4,0,3.6-.4,4.4-1.2,1.1-1.1,1.7-3.2,1.8-7.8h-6.5c0,2.9-.4,3.3-.6,3.5h0Z",
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.6,55.2c.1-.1.6-.3,1.5-.3h2.9c1,0,1.2,0,1.5.3s.4.6.6,3.5h6.5c0-4.6-.6-6.5-1.8-7.6-.8-.8-2.1-1.2-4.4-1.2h-7.6c-2.4,0-3.6.4-4.4,1.2-1.2,1.2-2.4,3.5-2.5,9h7.2c0-4,.4-4.6.6-4.9h0Z",
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.3,
    y: 49.6,
    width: 6.9,
    height: 22.6,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 67.1,
    width: 9.7,
    height: 5.3,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 49.6,
    width: 9.7,
    height: 5.3,
    style: {
      fill: "#c87349"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.7 66.8 64.5 67.3 65.1 66.7 65.1 62.7 63.7 63.9 63.7 66.8",
    style: {
      fill: "#025061"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.2 61 67.7 59.6 67.7 59.6 67.7 56.2 66.2 57.3 66.2 61",
    style: {
      fill: "#025061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,49.6v2.5h-1.9v-2.5c-5.8.4-10.5,5.4-10.5,11.4s4.6,11,10.5,11.4v-3.1h1.9v3.1c5.8-.4,10.5-5.4,10.5-11.4s-4.6-11-10.5-11.4ZM74.5,62.4h-.4l-1.1-.6-1,1.5c0,.1-.3.1-.3,0l-1.4-.8s-.1-.1-.1-.3v-3.6h-.4c0-.1-1,.7-1,.7v5.1q0,.3-.3.1l-.6-.4s-.1-.1-.1-.3v-3.9l-1.5,1.4v4.9l-1.4,1.4h-.4l-1.5-.8s-.1-.1-.1-.3v-2.6s0-.3.1-.3l2.4-2.1v-3.9l-2.4,1.7h-.3v-.3s0-.3.1-.3l6-4.3c.1,0,.3,0,.3.1v.3h0v3.6l1-1h.4l1,.4s.1,0,.1.3v3.9l.6.3.7-1.1h0v-4.7l1-.8h.3l1.5.8c.1,0,.1.3,0,.3l-1.9,3.2v1l.8.4,2.1-2.2h.3c.1.1.1.3,0,.4l-2.5,2.6h.1Z",
    style: {
      fill: "#025061"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.8 57 73.8 56.4 73.5 56.6 73.5 59.1 74.8 57",
    style: {
      fill: "#025061"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9,64.7c0,3.1-1.5,4.7-3.3,4.7s-1.9-.5-2.5-1.2v1h-1.3v-11.5l1.3-.7v4.5c.6-.7,1.5-1.3,2.7-1.3,1.8,0,3.2,1.3,3.2,4.4ZM36.6,64.7c0-2.2-.8-3.4-2.2-3.4s-1.7.5-2.3,1.3v4.4c.5.7,1.3,1.3,2.4,1.3s2.2-1.3,2.2-3.6Z",
    style: {
      fill: "#025061"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6,60.4l-4.4,11.9h-1.3l1.2-3.2-3.1-8.7h1.3l2.1,6.4.3.9.3-.9,2.2-6.4h1.3Z",
    style: {
      fill: "#025061"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.7 6.9 0 7 0 .6 27.2 .6 27.2 6.9 17.5 6.9 17.6 37 9.7 37 9.7 6.9",
    style: {
      fill: "#085263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8,14.5c0-5-.7-7.9-2.5-10.1C52.9,1.3,49.5,0,44,0s-8.3,1.1-10.7,3.7c-2.2,2.3-3.1,5.3-3.1,10.8v8.6c0,5,.7,7.9,2.5,10.1,2.4,3.1,5.8,4.3,11.3,4.3s8.3-1.1,10.8-3.7c2.2-2.3,3.1-5.3,3.1-10.8v-8.6h0ZM44,31.2c-4.4,0-5.9-2.2-5.9-8.8v-7.2c0-6.6,1.5-8.8,6-8.8s5.9,2.2,5.9,8.8v7.2c0,6.6-1.5,8.8-6,8.8Z",
    style: {
      fill: "#085263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1.6v22.8c0,3,.2,4.4.8,5.5.9,1.7,2.2,2.3,4.8,2.3s4.2-.8,5-2.8c.5-1.1.6-2.5.6-5.1V.5h7.8v22.8c0,5.5-.5,7.9-2.2,10-2.4,3-5.7,4.2-11.2,4.2s-9.4-1.5-11.7-4.8c-1.3-2-1.8-4.3-1.8-9.3V.6h7.9Z",
    style: {
      fill: "#085263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,21.9c4.7-1.3,6.6-4.3,6.6-10.6s-.8-6.2-2.7-8.1c-1.9-1.9-4.5-2.7-9.4-2.6h-13.8v36.4h7.9v-14.5h3.8l6.8,14.5h8.7l-7.9-15.1ZM109.8,16.4h-5.5V6.7h5.4c3.7,0,5.1,1.3,5.1,4.8s-1.4,4.8-5,4.8h0Z",
    style: {
      fill: "#085263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,18.5h11v5.4c0,4.7-.8,7.4-2.9,9.7-2.2,2.5-5.4,3.7-9.4,3.7s-7.9-1.6-10-4.7c-1.6-2.3-2.2-5.2-2.2-10.3v-7.2c0-5.6.7-8.6,2.7-11.1,2.1-2.7,5.2-4,9.3-4,6.5,0,10.8,3.3,11.2,8.4l-2.3.2c-.6-4.1-3.9-6.5-8.8-6.5s-9.6,3.9-9.6,12.9v7.2c0,9,3,12.8,9.7,12.8s6.1-1.1,7.8-3.4c1.5-1.9,2-3.9,2-7.5v-3.7h-8.6v-2.1.2Z",
    style: {
      fill: "#c77349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,.5v23.2c0,4.1.4,6.1,1.6,7.9,1.7,2.6,4.1,3.7,7.9,3.7s6.6-1.3,8.2-4.2c.9-1.6,1.3-3.6,1.3-7.3V.5h2.4v23.2c0,5-.5,7.2-2.1,9.4-2.2,2.9-5.3,4.2-9.8,4.2s-8.1-1.6-10.2-4.9c-1.3-2-1.7-4.2-1.7-8.8V.5h2.4Z",
    style: {
      fill: "#c77349"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.5,
    y: 0.5,
    width: 2.4,
    height: 36.4,
    style: {
      fill: "#c77349"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,14.2c.3-8.8-4.4-13.8-12.8-13.7h-11.1v36.4h11.1c8.4,0,13.1-4.9,12.8-13.7v-9ZM218.9,34.8h-8.3V2.7h8.3c7.1-.2,10.8,4,10.7,11.8v8.4c.2,7.9-3.6,12-10.7,11.9Z",
    style: {
      fill: "#c77349"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.2 .5 261.7 .5 261.7 2.6 243.7 2.6 243.7 17.4 259 17.4 259.1 19.5 243.7 19.5 243.7 34.8 261.6 34.8 261.6 36.9 241.3 36.9 241.2 .5",
    style: {
      fill: "#c77349"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSiteSeeLogo);
export default __webpack_public_path__ + "static/media/DesktopSiteSeeLogo.c3d2696d0880939e1d85256509570142.svg";
export { ForwardRef as ReactComponent };